import Vue from 'vue'
import Router from 'vue-router'
import top from '@/views/top'
// import detail from '@/views/detail'
// import detail from '@/views/test'

Vue.use(Router)
export default new Router({
  // mode: 'history',

  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      gtag('config', 'UA-23323223-20', {'page_path': location.pathname+location.hash}); // megahobby.jp
      // gtag('config', 'UA-115352966-1', {'page_path': location.pathname+location.hash}); // cdunited.net
      return { x: 0, y: 0 }
    }
  },

  routes: [
    {
      path: '/',
      name: 'top',
      component: top
    },
    {
      path: '/index.html',
      name: 'index',
      component: top
    },
    // {
    //   path: '/:path',
    //   name: 'detail',
    //   component: detail
    // },
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js